import {  disbursementConstants, nameSpace } from "../constants/disbursement.constants";

const initialState = {
  loading: false,
  success: false,
  request: null,
  response: null,
  error: null
};

export const putDisbursement = (state = initialState, action) => {
 
  switch (action.type) {
    case disbursementConstants[`PUT_${nameSpace}_REQUEST`]:
      return {
        ...state,
        loading: true,
        request: action.request
      };
    case disbursementConstants[`PUT_${nameSpace}_SUCCESS`]:
      return {
        ...state,
        loading: false,
        success: true,
        response: action.response,
        error: null
      };
    case disbursementConstants[`PUT_${nameSpace}_FAILURE`]:
        
      return {
        ...state,
        loading: false,
        success: false,
        error: action.error
      };
    case disbursementConstants[`PUT_${nameSpace}_RESET`]:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
